import { css, styled } from '@mui/material';

import { getPageCount } from '../../utils';
import { paginationDisplayedRowsClasses } from './theme';

import type { PaginationDisplayedRowsProps, PaginationInfo } from './types';

function defaultRenderLabelDisplayedRows({ from, to, count, hasMore }: PaginationInfo) {
  return (
    <PaginationDisplayedRowsHighlight>{`${from} – ${to} / ${count !== -1 ? (hasMore ? `${count}+` : count) : `${to}+`}`}</PaginationDisplayedRowsHighlight>
  );
}

const PaginationDisplayedRows = (props: PaginationDisplayedRowsProps) => {
  const {
    rowsPerPage,
    page,
    count,
    hasMore,
    renderLabelDisplayedRows = defaultRenderLabelDisplayedRows,
  } = props;

  const getLabelDisplayedRowsTo = () => {
    if (count === -1) {
      return (page + 1) * rowsPerPage;
    }
    return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
  };

  return (
    <PaginationDisplayedRowsRoot>
      {renderLabelDisplayedRows({
        from: count === 0 ? 0 : page * rowsPerPage + 1,
        to: getLabelDisplayedRowsTo(),
        count: count === -1 ? -1 : count,
        page,
        lastPage: getPageCount({ count, rowsPerPage }) - 1, // zero based page index 처리를 위해 -1 계산
        hasMore,
      })}
    </PaginationDisplayedRowsRoot>
  );
};

export default PaginationDisplayedRows;

const PaginationDisplayedRowsRoot = styled('p', {
  target: paginationDisplayedRowsClasses.root,
})(
  () => css`
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #323841;
  `,
);

const PaginationDisplayedRowsHighlight = styled('span', {
  target: paginationDisplayedRowsClasses.highlight,
})(
  () => css`
    font-weight: 500;
    color: #111111;
  `,
);
